import { Message } from 'antd';
import { useEffect, useState } from "react";
import SendRewardModal from "../../presentation/sendRewardModal/SendRewardModal.jsx";
import { useHomeService } from '../../service/home.services.jsx';
import { BADGE_TYPE, REVERSE_MAPING_BADGE_TYPE, ICON_COMPLETE_MAP } from '../../../RnRCommonComponent/CoreBadge/rewardsConstants';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { useSelector } from 'react-redux';

// GraphQL query to fetch badges by company ID
const QUERY_BADGES_BY_COMPANY_ID = gql`
  query QueryBadgesByCompanyIdIndex($companyId: ID!, $limit: Int, $nextToken: String) {
    queryBadgesByCompanyIdIndex(companyId: $companyId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyId
        badgeTypeId
        assignmentSSORequiredId
        recipientPayTypeId
        recipientSSORequiredId
        physicalAwardActivityId
        iconId
        snappyGrantId
        snappyGrant {
          id
          snappyCampaignId
          name
          description
          costInCurrency
        }
        name
        label
        description
        image
        color
        gradientColor
        points
        bonusPoints
        rewardBonus
        rewardMaxBonus
        assignmentLimit
        assignmentLevelId
        recipientLevelId
        isPreApproved
        isRewardRequiresDate
        visibility
        isAssignmentSSORequired
        isRecipientSSORequired
        automationRule
        externalWorkFlowId
      }
      nextToken
    }
  }
`;

const SendRewardContainer = (props) => {

  const {
    setSendRewardObject,
    sendrewardObject,
    setIsOpenRewardModel,
    recipientId,
    handleSendShoutout
  } = props;
  const [employeeData, setEmployeeData] = useState()
  const [badgeDetailObject, setBagdeDetailObject] = useState({})
  const [badgeData, setBadgeData] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [isBadgeLoading, setIsBadgeLoading] = useState(false)
  const [errorObject, setErrorObject] = useState({})
  const [rewardsAvailable, setRewardsAvailable] = useState(true);
  const homeAPIService = useHomeService();

  // Get current user from Redux state
  const currentUser = useSelector(state => state.user.currentUser);

  const getEmployeeList = (search) => {
    homeAPIService.getEmployeeList({ search: search }).then((response) => {
      if (response?.code === 200) {
        setEmployeeData(response?.data)
      } else {
        Message.error('Failed to fetch employee list');
      }
    }).catch((error) => {
      console.log(error);
      Message.error('Failed to fetch employee list');
    });
  };

  // GraphQL query to fetch badges by company ID
  const QUERY_BADGES_BY_COMPANY_ID = gql`
    query QueryBadgesByCompanyIdIndex($companyId: ID!, $limit: Int, $nextToken: String) {
      queryBadgesByCompanyIdIndex(companyId: $companyId, limit: $limit, nextToken: $nextToken) {
        items {
          id
          companyId
          badgeTypeId
          assignmentSSORequiredId
          recipientPayTypeId
          recipientSSORequiredId
          physicalAwardActivityId
          iconId
          snappyGrantId
          snappyGrant {
            id
            snappyCampaignId
            name
            description
            costInCurrency
          }
          name
          label
          description
          image
          color
          gradientColor
          points
          bonusPoints
          rewardBonus
          rewardMaxBonus
          assignmentLimit
          assignmentLevelId
          recipientLevelId
          isPreApproved
          isRewardRequiresDate
          visibility
          isAssignmentSSORequired
          isRecipientSSORequired
          automationRule
          externalWorkFlowId
        }
        nextToken
      }
    }
  `;

  // Use client from props (provided by withApollo HOC)

  const getAllBadgeList = async (badgeType, page, limit, search) => {
    try {
      setIsBadgeLoading(true);
      
      // Use currentUser from Redux state
      const companyId = currentUser?.companyId || currentUser?.company?.id;
      
      console.log('Debug Badge Fetch - currentUser:', currentUser);
      console.log('Debug Badge Fetch - companyId:', companyId);
      
      if (!companyId) {
        console.error('Company ID not found');
        setIsBadgeLoading(false);
        return;
      }
      
      console.log('Debug Badge Fetch - Starting GraphQL query');
      
      // Use GraphQL to fetch badges
      const { data, error } = await props.client.query({
        query: QUERY_BADGES_BY_COMPANY_ID,
        variables: {
          companyId: companyId,
          limit: limit || 100,
          nextToken: null
        },
        fetchPolicy: 'network-only'
      });
      
      console.log('Debug Badge Fetch - GraphQL response data:', data);
      console.log('Debug Badge Fetch - GraphQL response error:', error);
      
      if (error) {
        console.error('Error fetching badges by company ID:', error);
        setIsBadgeLoading(false);
        return;
      }
      
      if (data?.queryBadgesByCompanyIdIndex?.items) {
        console.log('Debug Badge Fetch - Raw badges:', data.queryBadgesByCompanyIdIndex.items);
        
        // Process the GraphQL response
        const enrichedBadges = data.queryBadgesByCompanyIdIndex.items.map(badge => {
          const badgeTypeCode = REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || '';
          
          let iconInfo = null;
          let iconCode = null;
          if (badge.iconId) {
            iconInfo = ICON_COMPLETE_MAP.find(icon => icon.id === badge.iconId);
            iconCode = iconInfo?.code;
          }
          
          return {
            ...badge,
            badgeType: badgeTypeCode,
            badgeTypeCode: badgeTypeCode, // For SendRewardSlider compatibility
            iconInfo,
            iconCode // For SendRewardSlider compatibility
          };
        });
        
        console.log('Debug Badge Fetch - Enriched badges:', enrichedBadges);
        
        // Filter badges by type and search term if provided
        const filteredBadges = enrichedBadges.filter(badge => {
          // Show all badge types if no specific type is provided, or match the specific type
          const matchesType = !badgeType || badge.badgeType === badgeType;
          const matchesSearch = !search || badge.name.toLowerCase().includes(search.toLowerCase());
          const isVisible = badge.visibility !== false;
          
          return matchesType && matchesSearch && isVisible;
        });
        
        console.log('Debug Badge Fetch - Filtered badges:', filteredBadges);
        
        setBadgeData(filteredBadges);
        const rewardsExist = filteredBadges.length > 0;
        setRewardsAvailable(rewardsExist);
      } else {
        console.log('Debug Badge Fetch - No items in response');
      }
    } catch (error) {
      console.error('Error fetching badges:', error);
      Message.error('Failed to fetch recognitions list! Try again later.');
    } finally {
      setIsBadgeLoading(false);
    }
  };

  const fetchInitialData = () => {
    setIsBadgeLoading(true)
    getAllBadgeList() // Load all badge types instead of just PEERTOPEER
  }

  useEffect(() => {
    getEmployeeList()
    fetchInitialData()
  }, [])

  const handleSendReward = async () => {
    if (
      !Boolean(sendrewardObject?.employeeDetail) ||
      !Boolean(sendrewardObject?.badgeAssignmentReason) ||
      !Boolean(sendrewardObject?.rewardtype)) {
      setErrorObject({
        ...errorObject,
        badgeAssignmentReason: !Boolean(sendrewardObject?.badgeAssignmentReason),
        rewardtype: !Boolean(sendrewardObject?.rewardtype),
        employeeDetails: !Boolean(sendrewardObject?.employeeDetail)
      })
      return
    }

    const sendData = {
      rewardPoints: sendrewardObject?.addBonus,
      badgeAssignmentReason: sendrewardObject?.badgeAssignmentReason,
      badgeId: sendrewardObject?.rewardtype,
      employeeId: sendrewardObject?.employeeDetail
    }

    setIsLoading(true)
    homeAPIService.createBadgeAssignment(sendData).then(async (response) => {
      if (response.code === 200) {
        setIsLoading(false)
        setIsOpenRewardModel(false)
        Message.success(response.message);
        setSendRewardObject(null)
      }
      else {
        setIsLoading(false)
        setSendRewardObject(null)
        Message.error(response.message);
      }
    })
  };

  return <>
    <SendRewardModal
      getEmployeeList={getEmployeeList}
      badgeDetailObject={badgeDetailObject}
      setBagdeDetailObject={setBagdeDetailObject}
      setIsOpenRewardModel={setIsOpenRewardModel}
      sendrewardObject={sendrewardObject}
      setSendRewardObject={setSendRewardObject}
      employeeData={employeeData}
      badgeData={badgeData}
      isBadgeLoading={isBadgeLoading}
      setIsBadgeLoading={setIsBadgeLoading}
      handleSendReward={handleSendReward}
      setEmployeeData={setEmployeeData}
      errorObject={errorObject}
      setErrorObject={setErrorObject}
      isLoading={isLoading}
      rewardsAvailable={rewardsAvailable}
      handleSendShoutout={handleSendShoutout}
    />
  </>;
};

export default withApollo(SendRewardContainer);
